var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.filteredTabs),function(ref,i){
var id = ref.id;
var label = ref.label;
return _c('button',{key:id || label,staticClass:"tab",class:[
      i === _vm.activeIndex ? 'border-primary text-primary' : 'border-white text-color-base' ],attrs:{"type":"button"},on:{"click":function($event){return _vm.setActiveIndex(i)}}},[_vm._v("\n    "+_vm._s(label)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }